<template>
    <mdb-col sm="4" class="col-no-left-pad">
        <mdb-card>
          <mdb-card-body>
            <mdb-card-title>Cloud</mdb-card-title>
            <mdb-card-text>
                
                <mdb-badge v-for="(cloudText, key) in tag_data" :test="key" :key="key" class=" badge-color" >
                    
                    <h1 v-if="random_num[key]==1" v-html="cloudText['heading']"> </h1>
                    <h2 v-if="random_num[key]==2" v-html="cloudText['heading']"> </h2>
                    <h3 v-if="random_num[key]==3" v-html="cloudText['heading']"> </h3>
                    <h4 v-if="random_num[key]==4" v-html="cloudText['heading']"> </h4>
                    <h5 v-if="random_num[key]==5" v-html="cloudText['heading']"> </h5>
                    <h6 v-if="random_num[key]==6" v-html="cloudText['heading']"> </h6>
                 </mdb-badge>
                
            </mdb-card-text>            
          </mdb-card-body>
        </mdb-card>
    </mdb-col>

</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbRow, mdbCol, mdbBadge } from 'mdbvue';
  
export default {
    name: 'TagClouds',
    data() {
        return {
            tag_data: [],
            random_num:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
           
        };
                
    },
    components: {
            mdbCard,
            mdbCardBody,
            mdbCol,
            mdbRow,
            mdbCardTitle,
            mdbCardText,
            mdbBtn,
            mdbBadge
        },
    created :function(){
        this.generateRandom(),
        this.showCloudContent()       
        
        },
    methods:{
        showCloudContent(){ 
            axios.get(this.$store.state.apiUrl+'/cloud_content',{
                params:{
                    id_language:this.$store.state.languageId,
                    id_company:this.$store.state.companyData['id_company']
                    
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                this.tag_data = response;
                this.$nextTick(function () {
                    
                })
            
            })
            .catch(() => {
                this.tag_data = [];
            });
        },

        generateRandom(){
            var j
            for(j=0;j<8;j++){
                this.random_num[j] = Math.floor((Math.random() * 6) + 1);
            }
        }

    }
}
</script>

<style scoped>
    .badge-color {
        background-color: #67676791 !important;
        margin: 0px 25px 25px 0;
    }
    .col-no-left-pad{
        padding-left: 0px;
        padding-right: 0px;
    }
</style>